import React from 'react';
import pt from 'prop-types';
import Overlay from 'components/overlay';
import { StorefrontEditorSidebarIcon } from 'components/storefront/editor/icon';
import { EasyblocksBackendContext } from 'components/storefront/editor/backendContext';
import {
  getDocumentPage,
  removeSwellPagePrefix,
} from 'components/storefront/editor/utils/easyblocks';
import {
  addPageItem,
  getSectionsToAdd,
  getBlocksToAdd,
} from 'components/storefront/editor/utils/overlay';

export default class AddPageItemOverlay extends React.PureComponent {
  static propTypes = {
    pageId: pt.string.isRequired,
    easyblocksConfig: pt.object.isRequired,
    editorConfig: pt.object.isRequired,
    data: pt.shape({
      domRect: pt.instanceOf(DOMRect).isRequired,
      path: pt.string.isRequired,
      overlayProps: pt.object,
    }),
    onClose: pt.func.isRequired,
  };

  state = {
    document: null,
  };

  componentDidMount() {
    this.setDocument();
  }

  setDocument() {
    const { pageId } = this.props;
    const { easyblocksState } = this.context;

    this.setState({ document: getDocumentPage(pageId, easyblocksState) });
  }

  getSectionInsertPath(path) {
    const { document } = this.state;
    const [sectionGroup, sectionIndex] = path.split('.');

    return {
      path: sectionGroup,
      index: sectionIndex || document[sectionGroup].length,
    };
  }

  getBlockInsertPath(path) {
    const { document } = this.state;
    const [sectionGroup, sectionIndex, blockGroup, blockIndex] =
      path.split('.');

    return {
      path: `${sectionGroup}.${sectionIndex}.${blockGroup}`,
      index:
        blockIndex || document[sectionGroup][sectionIndex][blockGroup].length,
    };
  }

  getInsertPath(eventPath) {
    const path = removeSwellPagePrefix(eventPath);
    const [, , blockGroup] = path.split('.');

    return blockGroup
      ? this.getBlockInsertPath(path)
      : this.getSectionInsertPath(path);
  }

  onAddItem = (event) => {
    const { easyblocksConfig, data, onClose } = this.props;
    const { templateId } = event.currentTarget.dataset;
    const { path, index } = this.getInsertPath(data.path);

    addPageItem(easyblocksConfig, templateId, path, index);
    onClose();
  };

  renderItem = (item, index) => {
    const { id, type, label } = item;

    return (
      <button
        key={index}
        type="button"
        className="storefront-editor--overlay-item"
        data-template-id={id}
        onClick={this.onAddItem}
      >
        <StorefrontEditorSidebarIcon type={label || type} />
        {label}
      </button>
    );
  };

  getItems() {
    const { editorConfig, easyblocksConfig, data } = this.props;
    const { document } = this.state;
    const path = removeSwellPagePrefix(data.path);
    const hasPath = path?.length > 0;

    if (!hasPath) {
      return null;
    }

    const [, , blockGroup] = path.split('.');

    if (!blockGroup) {
      return getSectionsToAdd(editorConfig, easyblocksConfig, path);
    }

    const { blocks } = getBlocksToAdd(
      editorConfig,
      easyblocksConfig,
      document,
      path,
    );

    return blocks;
  }

  render() {
    const { data, onClose } = this.props;
    const { document } = this.state;

    if (!document) {
      return null;
    }

    const items = this.getItems();
    const hasItems = items?.length > 0;

    if (!hasItems) {
      return null;
    }

    return (
      <Overlay
        className="storefront-editor--overlay"
        domRect={data.domRect}
        items={items}
        renderItem={this.renderItem}
        onClose={onClose}
        {...data.overlayProps}
      />
    );
  }
}

AddPageItemOverlay.contextType = EasyblocksBackendContext;
